import styled from 'styled-components';
import { spacer, multiply } from '@whitelabel/helpers/style/units';

export const StyledBrandLogo = styled.img`
  display: block;
  width: auto;
  height: ${multiply(spacer, 2)};
`;
